import styled from "styled-components";

// tslint:disable-next-line
export const BareUl = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;
